'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = require('../util');

var _constants = require('../constants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  isFetching: false,
  currentUser: null,
  errors: [],
  isFetchingOrders: false,
  archivedOrderId: null
};

var authenticateMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.USER_AUTHENTICATE_START, _constants.USER_AUTHENTICATE_FAILURE);

var registerMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.USER_REGISTER_START, _constants.USER_REGISTER_FAILURE);

var logoutMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.USER_LOGOUT_START, _constants.USER_LOGOUT_FAILURE);

var loadMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.USER_LOAD_START, _constants.USER_LOAD_FAILURE);

exports.default = (0, _util.createReducer)(initialState, _extends({}, authenticateMethods, registerMethods, logoutMethods, loadMethods, (_extends2 = {}, _defineProperty(_extends2, _constants.USER_AUTHENTICATE_SUCCESS, function (state, _ref) {
  var data = _ref.data;

  return _extends({}, state, {
    currentUser: data,
    isFetching: false
  });
}), _defineProperty(_extends2, _constants.USER_REGISTER_SUCCESS, function (state, _ref2) {
  var data = _ref2.data;

  return _extends({}, state, {
    currentUser: data,
    isFetching: false
  });
}), _defineProperty(_extends2, _constants.USER_LOGOUT_SUCCESS, function (state, action) {
  return _extends({}, state, {
    currentUser: null,
    isFetching: false
  });
}), _defineProperty(_extends2, _constants.USER_UPDATE_ACCESSTOKEN, function (state, _ref3) {
  var accessToken = _ref3.accessToken;

  return _extends({}, state, {
    currentUser: _extends({}, state.currentUser, {
      accessToken: accessToken
    })
  });
}), _defineProperty(_extends2, _constants.USER_LOAD_SUCCESS, function (state, _ref4) {
  var data = _ref4.data;

  return _extends({}, state, {
    currentUser: data,
    isFetching: false
  });
}), _defineProperty(_extends2, _constants.USER_LOAD_ORDERS_START, function (state) {
  return _extends({}, state, {
    isFetchingOrders: true
  });
}), _defineProperty(_extends2, _constants.USER_LOAD_ORDERS_SUCCESS, function (state, _ref5) {
  var data = _ref5.data;

  var currentUser = state.currentUser;
  var newState = _extends({}, state, {
    isFetching: false,
    isFetchingOrders: false
  });

  if (data && data.orders) {
    newState.currentUser = _extends({}, currentUser, {
      orders: data.orders
    });
  }

  return newState;
}), _defineProperty(_extends2, _constants.USER_LOAD_ORDERS_FAILURE, function (state) {
  return _extends({}, state, {
    isFetchingOrders: false
  });
}), _defineProperty(_extends2, _constants.USER_RESET_ORDERS, function (state) {
  return _extends({}, state, {
    currentUser: _extends({}, state.currentUser, {
      orders: []
    }),
    isFetchingOrders: false
  });
}), _defineProperty(_extends2, _constants.USER_LOAD_BOOKING_REQUESTS_START, function (state) {
  return _extends({}, state, {
    isFetchingBookingRequests: true
  });
}), _defineProperty(_extends2, _constants.USER_LOAD_BOOKING_REQUESTS_SUCCESS, function (state, _ref6) {
  var data = _ref6.data;

  var currentUser = state.currentUser;
  var newState = _extends({}, state, {
    isFetching: false,
    isFetchingBookingRequests: false
  });

  if (data && data.bookingRequests) {
    newState.currentUser = _extends({}, currentUser, {
      bookingRequests: data.bookingRequests
    });
  }

  return newState;
}), _defineProperty(_extends2, _constants.USER_LOAD_BOOKING_REQUESTS_FAILURE, function (state) {
  return _extends({}, state, {
    isFetchingBookingRequests: false
  });
}), _defineProperty(_extends2, _constants.USER_SELECT_ARCHIVED_ORDER, function (state, action) {
  return _extends({}, state, {
    archivedOrderId: action.orderId
  });
}), _defineProperty(_extends2, _constants.USER_LOAD_CREDIT_CARDS_SUCCESS, function (state, _ref7) {
  var data = _ref7.data;

  var currentUser = state.currentUser;
  var newState = _extends({}, state, {
    isFetching: false
  });

  if (data && data.creditCards) {
    newState.currentUser = _extends({}, currentUser, {
      creditCards: data.creditCards
    });
  }

  return newState;
}), _defineProperty(_extends2, _constants.USER_DELETE_CREDIT_CARD_SUCCESS, function (state, _ref8) {
  var data = _ref8.data;

  var currentUser = state.currentUser;
  var newState = _extends({}, state, {
    isFetching: false,
    currentUser: _extends({}, currentUser, {
      creditCards: data
    })
  });
  return newState;
}), _defineProperty(_extends2, _constants.USER_ADD_TMP_NEW_CREDIT_CARD, function (state, _ref9) {
  var data = _ref9.data;

  var currentUser = state.currentUser;
  var savedCreditCards = currentUser.creditCards;
  var newState = _extends({}, state, {
    isFetching: false,
    currentUser: _extends({}, currentUser, {
      creditCards: [].concat(_toConsumableArray(savedCreditCards), [data])
    })
  });
  return newState;
}), _extends2)));


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/reducer/user.js
// module id = 431
// module chunks = 0